import React from 'react';
import Title from '../title';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import { Grid, Input, Button } from 'semantic-ui-react';
import Control from './control';
import ReadCookie from '../../functions/readcookies';
import Permission from '../../functions/permission';

class Executivebranch extends React.Component {

  state = {
    load: false,
    message: '',
    executiveBranch: [],
    allCustomer: [],
    allExecutive: [],
    mappedExecutive: [], menuPermission: [],
    executivebranchview: 'show'
  }

  componentDidMount() {
    this.menuControl();
  }

  menuControl() {
    let menuPermission = Permission('statement-mapping', this.props.menus);
    if (menuPermission.view) {
      this.setExecutiveCustomer();
    }
    this.setState({ menuPermission })
  }

  getCustomer() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Customers'
    })
    let url = Server() + 'customer/getallcustomer.php';
    $.ajax({
      type: 'POST',
      url: url,
      success: function(data)
      {
        let allCustomerOption = [];
        try {
          data = JSON.parse(data);
          console.log(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
            allCustomerOption.push({ key: data[i].id+'->'+data[i].name, text: data[i].id+'->'+data[i].name, value: data[i].id })
          }
          context.setState({
            load: false,
            allCustomer: data,
            allCustomerOption: allCustomerOption
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setExecutiveCustomer() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({
      load: true,
      message: 'Getting Executive!!!'
    });
    let url = Server() + 'statementmapping/get.php';
    $.ajax({
      type: 'POST',
      data: { 'executiveId': userId },
      url: url,
      success: function(data)
      {
        let allExecutive = [];
        let mappedExecutive = [];
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.type == "employee") {
              allExecutive.push({ key: c.name, text: c.name, value: c.id })
            }
            else {
              mappedExecutive.push(c);
            }
          })
          context.setState({
            executiveBranch: data,
            mappedExecutive: mappedExecutive,
            allExecutive: allExecutive,
            allCustomerOption: allExecutive
          })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  search = () => {
    let search = document.getElementById("search").value;
    this.setState({ search })
  }

  render() {
    let i = 0;
    let title = "Statement Mapping";
    return (
      <div>
        <Title title={title} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <Grid style={{display: this.state.executivebranchview}}>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                <br/>
                { this.state.allExecutive.length > 0 ?
                  (
                    <div style={{padding: '1.5%'}} id="scrollsss">
                      <br/>
                      <table width="100%" id="table">
                        <tr>
                          <th id='tableheader' style={{ width: '7%' }}>Sino<center></center></th>
                          <th id='tableheader' style={{ width: '30%' }}>Executive<center></center></th>
                          <th id='tableheader' style={{ width: '63%' }}>Executive Customers<center></center></th>
                        </tr>
                        { this.state.allExecutive.map((z) => {
                            i++
                            let y = [];
                            let id = z.value;
                            return (
                              <tr>
                                <td><center>{i}</center></td>
                                <td>{z.key}</td>
                                <td>
                                  { this.state.mappedExecutive.map((c) => {
                                      if (c.name == z.value) {
                                        y.push(c.id);
                                      }
                                    })
                                  }
                                  <Control eid={id} data={y}
                                    menuPermission={this.state.menuPermission}
                                    allCustomerOption={this.state.allCustomerOption}
                                    executivebranchedit={this.state.executivebranchedit}   />
                                </td>
                              </tr>
                             )
                          })
                        }
                      </table>
                    </div>
                  ) :
                  (
                    <div></div>
                  )
                }
                </Grid.Column>
              </Grid>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default Executivebranch;
